import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=10bde8bd&scoped=true&"
import script from "./ClientesForm.vue?vue&type=script&lang=js&"
export * from "./ClientesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bde8bd",
  null
  
)

export default component.exports